// react
import { useState } from 'react';

// i18n
import { useTranslation } from 'react-i18next';

// dialogs
import { DialogActions } from '../DialogActions/DialogActions';

// forms
import { FormEditDocumentType } from '../../forms/FormEditDocumentType/FormEditDocumentType';

// props
export interface DialogEditDocumentTypeProps {
	isOpen: boolean;
	onClose: () => void;
	onSuccess?: () => void;
}

export const DialogEditDocumentType = ({
	isOpen,
	onClose,
	onSuccess,
}: DialogEditDocumentTypeProps) => {
	// hooks
	const { t } = useTranslation();

	// state
	const [isLoading, setIsLoading] = useState(false);

	return (
		<DialogActions
			actions={[
				{
					children: t('cancel'),
					onClick: onClose,
				},
				{
					children: t('saveDocumentType'),
					loading: isLoading,
					form: 'form-edit-document-type',
					type: 'submit',
					variant: 'contained',
				},
			]}
			hasClose={true}
			isOpen={isOpen}
			maxWidth={400}
			onClose={onClose}
			title={{
				children: t('editDocumentType'),
				variant: 'h3',
			}}>
			<FormEditDocumentType onClose={onClose} onSuccess={onSuccess} setIsLoading={setIsLoading} />
		</DialogActions>
	);
};
